/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import ReactImageZoom from 'react-image-zoom';
import { useDispatch, useSelector } from "react-redux";
import "./ProductStyle.css";
import star from "./images/icons8-star-30.png";
import cart from "./images/cart.png";
import refresh from "./images/refresh.png";
import rupee from "./images/rupee.png";
import arrow from "./images/arrow.png";
import axios from "axios";
import Navbar from "./Navbar";
// import AllReviews from "./AllReviews";
// import ReviewForm from "./ReviewForm";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const Product = () => {
  const { cartProducts } = useSelector((state) => state.cartReducer);
  const quantity = 1;
  // const [isClicked, setIsClicked] = useState(false);
  // console.log("isclicked", isClicked);
  const [product, setProd] = useState(null);
  const { id } = useParams();

  // const isAuthenticate = () => {
  //   return localStorage.getItem("userTokenTime")
  // }

  function vw(v) {
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return (v * w) / 100;
  }

  useEffect(() => {
    axios.get(SERVER_URL + "/api/products/" + id).then((res) => {
      setTimeout(() => {
        console.log(res.data);
        setProd((prev) => res.data);
      }, 100);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [imageSrc, setImageSrc] = useState(0)




  const dispatch = useDispatch();
  // const { product } = useSelector((state) => state.productReducer);

  const btnclick = () => {
    axios
      .post(
        SERVER_URL +
        "/api/addtocart",
        {
          productId: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(localStorage.getItem("userTokenTime")).token,
          },
        }
      )
      .then((res) => {
        // setToken(res.data.token);
        // const data = {
        // token: res.data.token,
        // time: new Date().getTime(),
        // };
        // localStorage.setItem("userTokenTime", JSON.stringify(data));
        // setRedirect(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const inCart = cartProducts.find((pr) => pr._id === id);

  useEffect(() => {
    dispatch({ type: "PRODUCT", id });
    // eslint-disable-next-line
  }, [id]);
  // let imgsrc = "http://malaman.github.io/react-image-zoom/example/1.jpg"
  const props = { width: 400, height: 300, img: "" };
  return (
    <>
      <Navbar />
      {product && (
        <div className="product-container">
          <div className="row1">
            <div className="col-1" style={{ paddingTop: "0px" }}>
              <div className="product-img1" >
                <img
                  src={SERVER_URL + `/uploads/products/${product.pImages[0]}`}
                  width="78" height="100"
                  className={`${imageSrc === 0 ? "iborder" : ""}`}
                  onClick={() => setImageSrc(0)}
                  style={{ cursor: "pointer" }}
                  alt="" />
                <div className="product-img1">
                  <img
                    src={SERVER_URL + `/uploads/products/${product.pImages[1]}`}
                    className={`${imageSrc === 1 ? "iborder" : ""}`}
                    width="78" height="100"
                    onClick={() => setImageSrc(1)}
                    style={{ cursor: "pointer" }}
                    alt="" />
                </div>
              </div>
            </div>
            <div className="col-5">
              {/* <div className="product-img"> */}
              {/* <img
                  src={`http://127.0.0.1:4000/uploads/products/${product.pImages[imageSrc]}`}
                  alt="" /> */}
              <ReactImageZoom
                width={vw(28)}
                // zoomWidth={100}
                scale={1}
                img={SERVER_URL + `/uploads/products/${product.pImages[imageSrc]}`} />

              {/* </div> */}
            </div>
            <div className="col-6 pd-l">
              <div className="p-company">{product.pName}</div>
              <div className="p-name">{product.pDescription}</div>
              <div className="p-price">
                <span>
                  <strong>₹{Math.floor(product.pPrice * (100 - product.pOffer) / 100)}</strong>
                </span>
                <span style={{ fontWeight: 400, marginLeft: "12px", fontSize: "20px", opacity: "0.8", lineHeight: 1.2 }}>
                  MRP <s>₹{product.pPrice}</s>
                </span>
                <span style={{
                  fontWeight: 400, marginLeft: "12px", fontSize: "20px",
                  letterSpacing: ".5px",
                  color: "#ff905a"
                }}>
                  ({product.pOffer}% OFF)
                </span>
              </div>
              <div className="xyz">inclusive of all taxes</div>
              <div className="review-rating">
                <span>
                  <div className="star">
                    4.7
                    <img src={star} alt="" />
                  </div>
                </span>
                <span className="num">15728 ratings and 3491 reviews</span>
              </div>
              <div className="add-btn">
                {inCart ? (
                  <Link to={`/cart`}>
                    <button>
                      <div className="go">Go To Cart</div>
                      <div>
                        <img src={arrow} alt="" />
                      </div>
                    </button>
                  </Link>
                ) : (
                  <button
                    // disabled={!}
                    onClick={() => {
                      // setIsClicked(!isClicked);
                      if (localStorage.getItem("userTokenTime")) {
                        dispatch({
                          type: "ADD_TO_CART",
                          payload: { product, quantity },
                        });
                      }
                      else {
                        window.location.href = process.env.REACT_APP_LINK + "signin"
                      }
                      // btnclick();
                    }}
                  >
                    <div>
                      <img src={cart} alt="" />
                    </div>
                    <div className="add">Add To Cart</div>
                  </button>
                )}
              </div>
              <div className="seller">
                <div>
                  Seller:<span className="name">Cloudtail India</span>
                  <span>
                    <div className="rating">
                      4.5
                      <img src={star} alt="" />
                    </div>
                  </span>
                </div>
                <div className="return">
                  <span>
                    <img src={refresh} alt="" />
                  </span>
                  <span>30 Day Return Policy</span>
                </div>
                <div className="cod">
                  <span>
                    <img src={rupee} alt="" />
                  </span>
                  <span>Cash on Delivery Available</span>
                </div>
              </div>
              <div className="res">
                <div className="res-title">What Customers Said</div>
                <div>
                  <div className="property">
                    <div className="hdg">Fit</div>
                    <div className="ans">
                      <div className="fill">
                        <div className="ans-fill-1"></div>
                      </div>
                      <div className="caption">As Expected (77%)</div>
                    </div>
                  </div>
                  <div className="property">
                    <div className="hdg">Length</div>
                    <div className="ans">
                      <div className="fill">
                        <div className="ans-fill-2"></div>
                      </div>
                      <div className="caption">As Expected (84%)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row2">
          <AllReviews product={product}/>
      {isAuthenticate() ? (
        <ReviewForm product={product}/>
      ) : (
        <div className="mb-12 md:mx-16 lg:mx-20 xl:mx-24 bg-red-200 px-4 py-2 rounded mb-4">
          You need to login in for review
        </div>
      )}
          </div> */}
        </div>
      )}
    </>
  );
};

export default Product;
